module.exports = __webpack_public_path__ + "29f203bb2828c1aed048b446c8abb0ae.svg";